var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon05Revealer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 13.7H9.1c-1.1 0-2 .9-2 2v6.5c0 1.1.9 2 2 2h1.1c1.1 0 2-.9 2-2v-6.5c0-1.1-.9-2-2-2zm.5 8.5c0 .3-.2.5-.5.5H9.1c-.3 0-.5-.2-.5-.5v-6.5c0-.3.2-.5.5-.5h1.1c.3 0 .5.2.5.5v6.5zm6.5-6.3h-1.1c-1.1 0-2 .9-2 2v4.3c0 1.1.9 2 2 2h1.1c1.1 0 2-.9 2-2v-4.3c0-1.1-.9-2-2-2zm.5 6.3c0 .3-.2.5-.5.5h-1.1c-.3 0-.5-.2-.5-.5v-4.3c0-.3.2-.5.5-.5h1.1c.3 0 .5.2.5.5v4.3zm6.5-11.3h-1.1c-1.1 0-2 .9-2 2v9.3c0 1.1.9 2 2 2h1.1c1.1 0 2-.9 2-2v-9.3c0-1.1-.9-2-2-2zm.5 11.3c0 .3-.2.5-.5.5h-1.1c-.3 0-.5-.2-.5-.5v-9.3c0-.3.2-.5.5-.5h1.1c.3 0 .5.2.5.5v9.3zM27 6.4H6.4c-1.7 0-3 1.4-3 3v15.4c0 1.7 1.4 3 3 3H27c1.7 0 3-1.4 3-3V9.4c0-1.6-1.4-3-3-3zm1.5 18.5c0 .8-.7 1.5-1.5 1.5H6.4c-.8 0-1.5-.7-1.5-1.5V9.4c0-.8.7-1.5 1.5-1.5H27c.8 0 1.5.7 1.5 1.5v15.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon05Revealer);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_05_Revealer.21f08e6f.svg";
export { ForwardRef as ReactComponent };